import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { SideA } from '../../../asset/sides/SideA';
import { SideB } from '../../../asset/sides/SideB';
import { SideC } from '../../../asset/sides/SideC';
import { SideD } from '../../../asset/sides/SideD';
import { setValueOptions } from '../../../store/actions/setting';
import { getValueOption, valueOption } from '../../../store/selectors/selectors';
//@ts-ignore
import s from './OrientationSides.module.scss'

type sideT = {
    id: string
}

type OrientationSidesT = {
    children: any,
    id: string,
    values: sideT[],
    
}
let getSide: any = (type: string) => {
    switch (type) {
        case 'SideA': return SideA
        case 'SideB': return SideB
        case 'SideC': return SideC
        case 'SideD': return SideD
    }
}
export const OrientationSides = ({ ...props }: OrientationSidesT) => {
    let { values, id } = props;

    const dispatch = useDispatch();

    function onChangeValue(val: any) {
        dispatch(setValueOptions({ idParams: id, valueParam: val }))
    }
    let { selectValue }: valueOption = useSelector(state => getValueOption({idOptions: id})(state));



    return (
        <div className={s.headerSection}>
            <div className={s.sides}>
                {values.map((side: sideT) => {
                    let isActive = false;
                    if (selectValue === side['id']) isActive = true;
                    return (
                        <div className={s.sideItem} onClick={() => onChangeValue(side['id'])}>
                            {
                                React.createElement(getSide(side['id']), { isActive: isActive })
                            }
                        </div>
                    )
                })}


            </div>
        </div>
    )
}
